function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.4 4.098a1.2 1.2 0 011.2-1.2h1.6a1.2 1.2 0 011.2 1.2v1.6a1.2 1.2 0 01-1.2 1.2h-.4v3.073a.8.8 0 01.166.127L6.4 11.533c.051.05.093.106.128.165H9.6v-.4a1.2 1.2 0 011.2-1.2h1.6a1.2 1.2 0 011.2 1.2v1.6a1.2 1.2 0 01-1.2 1.2h-1.6a1.2 1.2 0 01-1.2-1.2v-.4H6.528a.803.803 0 01-.128.166l-1.434 1.434a.8.8 0 01-1.131 0L2.4 12.664a.8.8 0 010-1.131l1.435-1.435A.8.8 0 014 9.971V6.898h-.4a1.2 1.2 0 01-1.2-1.2v-1.6z",
  fill: "#8F90A6"
});

function SvgLifecycleDialogIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLifecycleDialogIcon;